import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Record } from '../RideDetails';

import styles from '../index.module.css';
import UberHealthIcon from '../../../../assets/svgs/uberHealth.svg';

export const VehicleInfo = ({ vehicleType, status, isUberRide, uberRideId }) => (
  <div
    className={classNames({
      [styles.vehicleInfo]: true,
    })}>
    <Record
      title='Vehicle Type'
      myClassName={styles.vehicleType}
      value={
        isUberRide ? (
          <span className={styles.uberHealthTag}>
            <img src={UberHealthIcon} alt="Uber Health" className={styles.uberHealthIcon} />
            {vehicleType}
          </span>
        ) : (
          vehicleType
        )
      }
    />
    {isUberRide && uberRideId ? (
      <Record title="Uber Ride ID" value={uberRideId} />
    ) : null}
  </div>
);

VehicleInfo.propTypes = {
  vehicleType: PropTypes.string,
  isUberRide: PropTypes.bool,
  uberRideId: PropTypes.string,
};
